import { AppButton } from 'components';
import * as AppPics from 'assets/images';

function RevisionNoteCard({ note, handleDelete }) {
  return (
    <div className="sliderSec-box">
      {/* IMAGE */}
      <img className="sliderSec-boxImg" src={note.image} alt="Revision Note" />
      {/* ACTION BUTTONS */}
      <div className="sliderSec-boxMore float-right gap-2 p-2">
        <AppButton variantClass="lessonWrap__btn" onClick={() => handleDelete(note)} title="Delete">
          <img src={AppPics.TrashBinSvg} alt="delete" />
        </AppButton>
      </div>
    </div>
  );
}

export default RevisionNoteCard;
